module.exports = __webpack_public_path__ + "img/13htgl.f9d3b1f3.svg";